
import { Company } from "@/models/company";
import Vue from "vue";
export default Vue.extend({
	props: {
		company: {
			type: Object as ()=>Company,
			required: true
		},
	},
	computed: {
		tabs():string[]{
			let result = [
				"Account",
				"Users",
				"Dossiers",
				"Modules",
				"Invoices",
				"Subscriptions",
				"CRM",
				"Billing",
				"Mails",
				"Bancontact terminals"
			];

			return result;
		},
		goBackToCompaniesToolTipText():string {
			return "Back to Accounts";
		},
		currentTab():number {
			return parseInt(this.$route.query.currentTab as string || "0");
		}
	},
	methods: {
		setTab(value:number){
			this.$router.push(`/companies/${this.company.id}/edit?currentTab=${value}`);
		},
		goBackToCompanies() {
			this.$router.push(`/companies`);
		},
	}
});
